import { render, staticRenderFns } from "./CreateWorkspacePage.vue?vue&type=template&id=7ef0cfcd&scoped=true"
import script from "./CreateWorkspacePage.vue?vue&type=script&lang=ts"
export * from "./CreateWorkspacePage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef0cfcd",
  null
  
)

export default component.exports